(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "normalizr", "@braindate/util/lib/assert", "./topicAssertions", "../schema"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("normalizr"), require("@braindate/util/lib/assert"), require("./topicAssertions"), require("../schema"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.normalizr, global.assert, global.topicAssertions, global.schema);
    global.topicNormalization = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _normalizr, _assert, _topicAssertions, _schema) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.hydrateTopic = hydrateTopic;
  _exports.hydrateTopics = hydrateTopics;
  _exports.normalizeTopic = normalizeTopic;
  _exports.normalizeTopics = normalizeTopics;

  /**
   * Normalize a topic
   * @param   {Topic} topic - Topic to normalize
   * @returns {number} data.result - Id of the topic
   * @returns {NormalizedData<number>} data.entities - Normalized data entities
   *
   * @throws Will throw an exception if parameter is not an object
   */
  function normalizeTopic(topic) {
    (0, _topicAssertions.assertTopic)(topic);
    return (0, _normalizr.normalize)(topic, _schema.topicSchema);
  }

  /**
   * Normalize topics
   * @param   {Array<Topic>} topics - Topics to normalize
   * @returns {Array<number>} data.result - Ids of the topics
   * @returns {NormalizedData<Array<number>>} data.entities - Normalized data
   * entities
   *
   * @throws Will throw an exception if parameter is not an array
   */
  function normalizeTopics(topics) {
    (0, _assert.assertArray)(topics, "topics");
    return (0, _normalizr.normalize)(topics, _schema.topicsSchema);
  }

  /**
   * Denormalize a topic
   * @param   {number} id - Id of the topic
   * @param   {Entities} entities - Normalized data entities
   * @returns {Topic} Denormalized topic
   *
   * @throws Will throw an exception if parameters are invalid
   */
  function hydrateTopic(id, entities) {
    (0, _assert.assertNumber)(id, "id");
    (0, _assert.assertObject)(entities, "entities");
    return (0, _normalizr.denormalize)(id, _schema.topicSchema, entities);
  }

  /**
   * Denormalize topics
   * @param   {Array<number>} ids - Ids of the topics
   * @param   {Entities} entities - Normalized data entities
   * @returns {Array<Topic>} Denormalized topics
   *
   * @throws Will throw an exception if parameters are invalid
   */
  function hydrateTopics(ids, entities) {
    (0, _assert.assertArray)(ids, "ids");
    (0, _assert.assertObject)(entities, "entities");
    return (0, _normalizr.denormalize)(ids, _schema.topicsSchema, entities);
  }
});